<template>
    <div v-if="placeId" class="w-full">
      <div class="justify-center sm:mx-auto rounded-3xl md:w-1/3 sm:w-1/2 mx-3 pt-3 pb-6 relative shadow-[0_15px_15px_0_rgba(0,0,0,0.1)]">
        <div v-if="paymentStatus == false">
        <div class="border-b border-purple mx-5 relative">
          <button class="absolute my-auto right-0" @click="changeLang()">{{showLangFlag()}}</button>
          <h2 class="font-gilroy-semi-bold text-md mb-1">{{ $t('fest-card-package-heading') }}</h2>
        </div>
        <div class="w-full mt-2">
          <p class="text-center font-gilroy-semi-bold py-2 text-3xl">{{ handleLang() == 'bg' ? name : nameEn }}</p>
        </div>
        <div v-if="cardData" class="mx-10">
            <div class="flex flex-row mx-10 items-center">
                <h2 class="w-1/2 text-purple font-gilroy-semi-bold">{{ $t('balance') }}</h2>
                <h2 class="w-1/2 text-right text-purple font-gilroy-semi-bold">{{ handlePrice(cardData.data.balance) }}</h2>
            </div>
            <div class="flex flex-row mx-10 items-center">
                <h2 class="w-1/2 text-purple font-gilroy-semi-bold">{{ $t('check-time') }}</h2>
                <h2 class="w-1/2 text-right text-purple font-gilroy-semi-bold">{{ formatDate(cardData.data.checkTime, 'DD.MM.YYYY HH:mm') }}</h2>
            </div>

            <p class="text-[#BEAAD2] mt-2 text-xs text-center">{{ $t('updated-at') }}: {{ formatDate(cardData.data.checkTime, 'HH:mm:ss DD.MM.YYYY') }}</p>
            
            <div class="w-full py-3 text-center">
                <button class="text-white bg-purple hover:opacity-80 px-5 py-2 rounded-full mx-auto" @click="clear()">
                    {{ $t('check-another-card-number') }}
                </button>
            </div>
        </div>
        <div v-else class="flex flex-col mx-10">
          <label for="cardNumber" class="my-3 text-purple font-gilroy-semi-bold">{{ $t('please-enter-card-number') }}</label>
          <div class="flex flex-row items-center">
            <input
              class="border border-purple rounded-full p-2 w-full text-center"
              type="text"
              :placeholder="$t('card-number-placeholder')"
              v-model="cardNumber"
            />
            <loading v-if="loading" class="mx-auto min-w-10"></loading>
            <button v-else @click="checkCard()" class="bg-purple text-white rounded-full py-2 ml-2 px-5">
              <font-awesome-icon icon="fa-solid fa-magnifying-glass" />
            </button>
          </div>
        </div>

        </div>
        <div v-if="placeData && paymentStatus == false" class="grid px-5 py-2 bg-purple mt-5">

          <!-- <label v-if="emailData.project_template && emailData.project_template.description_alt['general-terms']" for="terms" class="text-white text-sm">
            <input 
              class="appearance-none rounded-full align-middle h-3.5 w-3.5 cursor-pointer bg-white outline-none checked:bg-[#808285] checked:border-2 checked:border-white" 
              type="checkbox" 
              id="terms"
              v-model="generalTerms">
              {{ $t('general-terms-info') }} 
            <a :href="emailData.project_template.description_alt['general-terms']" class="underline" target="_blank">
              {{ $t('general-terms') }}
            </a>
          </label> -->

          <label v-if="placeData.terms && placeData.terms.file_url" for="owner-terms" class="text-white text-sm">
            <input 
              class="appearance-none rounded-full align-middle h-3.5 w-3.5 cursor-pointer bg-white outline-none checked:bg-[#808285] checked:border-2 checked:border-white" 
              type="checkbox" 
              id="owner-terms"
              v-model="ownerTerms"> 
              {{ $t('owner-terms-info') }} 
            <a :href="placeData.terms.file_url" class="underline" target="_blank">
              {{ $t('owner-terms') }}
            </a>
          </label>

          <label v-if="placeData.file && placeData.file.file_url" for="owner-file" class="text-white text-sm">
            <input 
            class="appearance-none rounded-full align-middle h-3.5 w-3.5 cursor-pointer bg-white outline-none checked:bg-[#808285] checked:border-2 checked:border-white" 
            type="checkbox" 
            id="owner-file"
            v-model="ownerFile"> 
              {{ $t('owner-file-info') }} 
            <a :href="placeData.file.file_url" class="underline" target="_blank">
              {{ $t('owner-file') }}
            </a>
          </label>
        
        </div>
        <div v-if="paymentStatus == false" class="flex flex-col mx-10">
          <div class="flex flex-row mx-10">
            <loading v-if="loading" class="mx-auto"></loading>
            <button v-else @click="load" class="bg-purple w-full text-white rounded-full p-2 px-3 mt-3">
                    {{ $t('load-package') }} {{ handlePrice(amount) }}
            </button>
          </div>
        </div>
        <!-- <div v-if="paymentStatus == 'success'" class="w-full">
            <div class="mt-2 mx-5 relative">
              <button class="absolute my-auto right-0" @click="changeLang()">{{showLangFlag()}}</button>
            </div>
            <div class="flex flex-col items-center justify-center">
                <div class="flex flex-col items-center mt-5">
                    <font-awesome-icon icon="fa-solid fa-circle-check" class="text-green-800 text-6xl mb-10" size="lg" />
                    <h2 class="text-3xl font-gilroy-semi-bold text-purple mb-2">{{ $t('successful-payment') }}</h2>
                </div>
                <div class="w-full py-3 mt-5 text-center">
                    <button class="text-white bg-purple hover:opacity-80 px-5 py-2 rounded-full mx-auto" @click="clear()">
                        {{ $t('check-another-card-number') }}
                    </button>
                </div>
            </div>
        </div>
        <div v-if="paymentStatus == 'fail'" class="w-full">
            <div class="mt-2 mx-5 relative">
              <button class="absolute my-auto right-0" @click="changeLang()">{{showLangFlag()}}</button>
            </div>
            <div class="flex flex-col items-center justify-center">
                <div class="flex flex-col items-center mt-5">
                    <font-awesome-icon icon="fa-solid fa-circle-xmark" class="text-red-800 text-6xl mb-10" size="lg" />
                    <h2 class="text-3xl font-gilroy-semi-bold text-purple mb-2">{{ $t('failed-payment') }}</h2>
                </div>
                <div class="w-full py-3 mt-5 text-center">
                    <button class="text-white bg-purple hover:opacity-80 px-5 py-2 rounded-full mx-auto" @click="clear()">
                        {{ $t('check-another-card-number') }}
                    </button>
                </div>
            </div>
        </div> -->
      </div>
      <footer-urboStudio></footer-urboStudio>
    </div>
  </template>
    
    <script>
    import {getFestCardData, loadFestCardData, makePaymentReq, getPlaceData} from '../api.js'
    import i18next from "i18next";
    import moment, { duration } from 'moment';
    import $ from 'jquery';
    export default {
      name: 'FestCard',
      props: {
          
      },
      data() {
        return {
            cardNumber: '',
            cardData: null,
            name: '',
            nameEn: '',
            amount: '',
            email: '',
            ownerId: '',
            placeId: '',
            cyrillicPattern : /[а-яА-ЯЁё]/,
            loading: false,
            sendReceipt: false,
            paymentStatus: false,
            placeData: null,
            ownerTerms: false,
            ownerFile: false,
            amount: null,
            price: null,
            duration: null,
        }
      },
      mounted() {
        if (this.$route.params.response) {
          this.paymentStatus = this.$route.params.response
        }
        if (this.$route.params.hash) {
          // if (this.$route.params.hash == '385cb9796464ff34f76739c1cde51977') {
          //   this.name = 'ОУ "Христо Ясенов"'
          //   this.nameEn = 'ОУ "Христо Ясенов"'
          //   this.ownerId = 4269
          //   this.placeId = 4972
          //   this.duration = 5
          //   this.price = 2
          //   this.amount = '10.00'
          // }
        }

        if (this.placeId) {
          getPlaceData({id: this.placeId})
          .then((res) => {
            if (res.data && res.data) {
              this.placeData = res.data
              this.placeData.terms = i18next.language == 'bg' ? JSON.parse(res.data.terms) : JSON.parse(res.data.terms_en)
              this.placeData.file = i18next.language == 'bg' ? JSON.parse(res.data.file) : JSON.parse(res.data.file_en)
            }
          })
        }
      },
      methods: {
        handlePrice(value){
        // @EUR
        // return  parseFloat(value).toFixed(2) + ' ' + this.$t('eur') + ' / ' + (value*1.95583).toFixed(2) + ' ' + this.$t('bgn')
        return  parseFloat(value).toFixed(2) + ' ' + this.$t('eur')
        },
        changeSum() {
          if (this.amount) {
            this.amount = this.amount.replace(',', '.');
          }
        },
        formatDate(date, format = 'DD-MM-YYYY', inputFormat = false) {
            if (inputFormat){
            return moment(date, inputFormat).format(format)
            }else{
            return moment(date).format(format)
            }
        },
        handleLang(){
          return i18next.language
        },
        showLangFlag(){
          if (i18next.language == 'bg') {
            return '🇬🇧'
          } else{
            return '🇧🇬'
          }
        },
        changeLang(){
          if (i18next.language == 'bg') {
            i18next.changeLanguage('en');
          } else{
            i18next.changeLanguage('bg');
          }
        },
        clear() {
          this.cardNumber = ''
          this.cardData = null
          this.paymentStatus = false

          if (window.location.href.indexOf('success') > -1 || window.location.href.indexOf('fail') > -1) {
            var url = window.location.href.split('/')
            url.splice(-1)
            var newUrl = url.join('/')
            this.$route.params.response = false
            window.location.href = newUrl
          }
        },
        load() {
          if (!this.cardNumber) {
            return this.$notify({type: 'error', text: this.$t('please-enter-card-number')});
          }
          if (!this.amount) {
            return this.$notify({type: 'error', text: this.$t('please-choose-amount')});
          }

          if (this.placeData.terms && this.placeData.terms.file_url && !this.ownerTerms) {
            return this.$notify({type: 'error', text: this.$t('owner-terms-required')})
          }
          if (this.placeData.file && this.placeData.file.file_url && !this.ownerFile) {
            return this.$notify({type: 'error', text: this.$t('owner-file-required')})
          }

          this.loading = true

          //check card exists before loading
          getFestCardData(this.cardNumber, this.placeId)
          .then((result) => {
            if (result.data) {
              var object = {
                user: { 
                  name: 'System Data', 
                  email: this.email ? this.email : 'system@urboapp.com'
                },
                total_sum: this.amount, 
                owner_id: this.ownerId,
                success_url: window.location.origin + '/#/payment/fcp/' + this.$route.params.hash + '/success',
                fail_url: window.location.origin + '/#/payment/fcp/' + this.$route.params.hash + '/error',
              }
              var body = {
                place_id: this.placeId,
                payment_method: 'mypos',
                options: object
              }
              loadFestCardData({
                place_id: this.placeId,
                card_id: this.cardNumber,
                amount: this.amount,
                price: this.price,
                count: this.duration,
                type: 'festcard-package'
              })
              .then((r) => {
                if (r.data && r.data.message) {
                  body.options.transaction_id = r.data.message.id
                  body.options = JSON.stringify(body.options)

                  makePaymentReq(body).
                  then((res) => {
                    if (res.data && res.data.params) {
                      const parser = new DOMParser();
                      var script = parser.parseFromString(res.data.params, "text/html");
                      // console.log(script);
                      $('body').html(res.data.params);
                      $('#ipcForm').submit();
                      return;
                    }
                  })
                }
              }) 
            }else{
                this.loading = false
                this.$notify({type: 'error', text: this.$t('card-not-found')});
            }
          })
          
        },  
        checkCard() {
          if (!this.cardNumber) {
            return this.$notify({type: 'error', text: this.$t('please-enter-card-number')});
          }
          if (this.cyrillicPattern.test(this.cardNumber)) {
            return this.$notify({type: 'error', text: this.$t('cyrillic-card-not-allowed')});
          }
          this.loading = true
          getFestCardData(this.cardNumber, this.placeId)
          .then((res) => {
            if (res.data) {
                this.loading = false
                this.cardData = res
                this.cardData.data.checkTime = new Date()
            }else{
                this.loading = false
                this.$notify({type: 'error', text: this.$t('card-not-found')});
            }
          })
        }
      },
    //   components:{
        
    //   }
    }
    </script>
    
    <style scoped>
    
    </style>
    